export {}

const DEFAULT_LOCALE = "pt-BR"
const DEFAULT_CURRENCY = "BRL"

const formatCurrency = (value: number, locale = DEFAULT_LOCALE, currency = DEFAULT_CURRENCY): string => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value)
}

declare global {
  interface Number {
    toStringOrEmpty(): string
    toMoney(locale?: string, currency?: string): string
    toDecimalString(fractionDigits?: number, locale?: string): string
    toPercentage(fractionDigits?: number, locale?: string): string
  }

  interface String {
    toMoney(locale?: string, currency?: string): string
  }
}

Number.prototype.toStringOrEmpty = function (): string {
  return this.valueOf() === 0 ? "" : this.toString()
}

Number.prototype.toMoney = function (locale = DEFAULT_LOCALE, currency = DEFAULT_CURRENCY): string {
  return formatCurrency(this.valueOf(), locale, currency)
}

Number.prototype.toDecimalString = function (fractionDigits = 2, locale = DEFAULT_LOCALE): string {
  return this.valueOf().toLocaleString(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}

Number.prototype.toPercentage = function (fractionDigits = 2, locale = DEFAULT_LOCALE): string {
  return `${this.toDecimalString(fractionDigits, locale)}%`
}

String.prototype.toMoney = function (locale = DEFAULT_LOCALE, currency = DEFAULT_CURRENCY): string {
  const cleanedValue = this.toString().replace(/[^\d,.-]/g, "").replace(/\.(?=\d{3}(\D|$))/g, "").replace(",", ".")
  const parsedValue = Number.parseFloat(cleanedValue)

  return Number.isNaN(parsedValue) ? (0).toMoney(locale, currency) : parsedValue.toMoney(locale, currency)
}
